/**
 * Filename: 不用节流接口白名单列表
 * Created Date:2021/9/23
 * Modifier: pyh
 * Author: pyh
 * 
 * Copyright (c) 2021 Your Company
 */
import CONFIG from '@/config';
let cloudURL = CONFIG.BASE_URL; // 云端接口地址

// 不需要节流判断的接口
let cloudThrottleURL = ['/video/clips', '/uims/wx_plant_info', '/video/clip/save'];
let cloudThrottle = cloudThrottleURL.map(item => cloudURL + item);

export let noThrottle = cloudThrottle;

// 不需要loading加载的接口
let cloudLoadingURL = ['/video/clips', '/uims/qrcode', '/uims/wx_plant_info'];
let cloudLoading = cloudLoadingURL.map(item => cloudURL + item);
export let noLoading = cloudLoading;
